import { ErrorKey } from '../app-active-error/ErrorKey';
import Logger from '../lib/Logger';
import { Metrics } from '../metrics/Metrics';
import { setError } from '../store/error/action-creators';
import { getRecaptchaSiteKey, getRecaptchaToken } from '../store/google-recaptcha/selectors';
import parseErrorData from '../store/signup-data-validation/utils/parseErrorData';
import { Tracker } from '../store/tracking/action-creators';
const LOG = Logger.getLogger('handleSignupError');
export const handleSignupError = (error, dispatch, getState) => {
  const statusCode = error.status;
  let message = 'unknown-message';

  if (error.data) {
    message = parseErrorData(error.data).message;
  }

  LOG.error('Signup Request Error', {
    extra: {
      message,
      statusCode
    }
  });

  if (statusCode === 429) {
    dispatch(Tracker.signupInteraction('creation-error-rate-limited'));
    return dispatch(setError(ErrorKey.RateLimitedCreationError, {
      message
    }));
  }

  if (error.data) {
    if (message && message.indexOf('verify_user_first') >= 0) {
      dispatch(Tracker.signupInteraction('creation-error-verify-first'));
      return dispatch(setError(ErrorKey.VerifyFirstCreationError, {
        message
      }));
    } else if (message === 'recaptcha failed') {
      LOG.error('/signup recaptcha error', {
        extra: {
          message,
          statusCode,
          recaptchaToken: getRecaptchaToken(getState()),
          recaptchaSiteKey: getRecaptchaSiteKey(getState())
        }
      });
      Metrics.counter('recaptcha-signup-error').increment();
      return dispatch(setError(ErrorKey.RecaptchaCreationError, {
        message
      }));
    } else if (message) {
      dispatch(Tracker.creationError('creation-error-standard', `${statusCode} - ${message}`));
    } else {
      dispatch(Tracker.creationError('creation-error-standard', 'error-unknown'));
    }
  }

  return dispatch(setError(ErrorKey.StandardCreationError, {
    message
  }));
};